import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom"; // v5

import { openModal, closeModal, fetchArticleDetail, fetchCatalogoDetail } from "redux/actions/global";
import { reportArticles } from "redux/actions/detail";
import ArticleCard from "components/Search/Article/ArticleCard/ArticleCard";

function DuplicateIdArticle(props) {
  const { profile, articles, history, itemId } = props;

  const handleOpenArticleDetail = (articleId) => {
    history.push(`/article_detail/${articleId}`);
  
  };

  return (
    <div tabIndex={1} className="modal-content duplicate-id-article-modal">
      <div className="modal-header">
        <h2>Encontramos 2 items relacionados a el id {itemId}</h2>
        <div className="panel-body live-search-articles duplicate-articles">
          {articles?.length > 0 &&
            articles.map((article, index) => (
              <div className="media-gal" key={`${article?.id || "sim"}-${index}`}>
                <ArticleCard
                  article={article}
                  onOpenArticleDetail={() => handleOpenArticleDetail(article.id)}
                  closeModal={() => closeModal()}
                  profile={profile}
                />
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  profile: state.global.profile,
  blindages: state.global.blindages,
  isAddingArticles: state.reportedArticles.isAddingArticles,
  progress: state.reportedArticles.progress,
});


export default withRouter(
  connect(mapStateToProps, {
    openModal,
    closeModal,
    reportArticles,
    fetchArticleDetail,
    fetchCatalogoDetail,
  })(DuplicateIdArticle)
);
